/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComponentClassResponseDto } from './ComponentClassResponseDto';
import {
    ComponentClassResponseDtoFromJSON,
    ComponentClassResponseDtoFromJSONTyped,
    ComponentClassResponseDtoToJSON,
    ComponentClassResponseDtoToJSONTyped,
} from './ComponentClassResponseDto';
import type { PaginationMetaDto } from './PaginationMetaDto';
import {
    PaginationMetaDtoFromJSON,
    PaginationMetaDtoFromJSONTyped,
    PaginationMetaDtoToJSON,
    PaginationMetaDtoToJSONTyped,
} from './PaginationMetaDto';

/**
 * 
 * @export
 * @interface ListComponentClassesResponseDto
 */
export interface ListComponentClassesResponseDto {
    /**
     * 
     * @type {Array<ComponentClassResponseDto>}
     * @memberof ListComponentClassesResponseDto
     */
    data: Array<ComponentClassResponseDto>;
    /**
     * 
     * @type {PaginationMetaDto}
     * @memberof ListComponentClassesResponseDto
     */
    meta: PaginationMetaDto;
}

/**
 * Check if a given object implements the ListComponentClassesResponseDto interface.
 */
export function instanceOfListComponentClassesResponseDto(value: object): value is ListComponentClassesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('meta' in value) || value['meta'] === undefined) return false;
    return true;
}

export function ListComponentClassesResponseDtoFromJSON(json: any): ListComponentClassesResponseDto {
    return ListComponentClassesResponseDtoFromJSONTyped(json, false);
}

export function ListComponentClassesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListComponentClassesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ComponentClassResponseDtoFromJSON)),
        'meta': PaginationMetaDtoFromJSON(json['meta']),
    };
}

export function ListComponentClassesResponseDtoToJSON(json: any): ListComponentClassesResponseDto {
    return ListComponentClassesResponseDtoToJSONTyped(json, false);
}

export function ListComponentClassesResponseDtoToJSONTyped(value?: ListComponentClassesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ComponentClassResponseDtoToJSON)),
        'meta': PaginationMetaDtoToJSON(value['meta']),
    };
}

